export default "__VITE_ASSET__CEDbEoyJ__"